import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatAccordionPanel } from '@blocks-react/components/AccordionPanel';
import style from '../Footer.module.scss';
import { CatHeading } from '@blocks-react/components/Heading';
export function FooterAccordionPanel({ title, children, }) {
    return (_jsxs(CatAccordionPanel, { alignToggleRight: true, children: [_jsx(CatHeading, { slot: "header", level: "h6", color: "knockout", "aria-label": title, children: title }), _jsx("ul", { className: style['footer__list'], children: children })] }));
}
